import { useRef } from "react";
import {
    DesVincularUsuarioGrupoController,
    ListarUsuariosPorGrupoController,
    ListarUsuariosPorGrupoNaoVinculadosController,
    VincularGruposUsuarioController,
} from "../../../../../Controllers/Geral/Grupos/GruposUsuarioController";
import useAsyncCallback from "../../../../../hooks/useAsyncCallback";
import useAsyncEffect from "../../../../../hooks/useAsyncEffect";
import { usuarioGrupo } from "../../../../../Interfaces/Geral/Grupos/GruposUsuarioInterface";
import UsuariosVinculadosPorGrupo from "./UsuariosDesvinculadosPorGrupo";
import UsuariosDesvinculadosPorGrupo from "./UsuarioVinculadosPorGrupo";

interface IUsuarios {
    idGrupo: number;
    updateUsers: (idGrupo: number) => void;
}

export default function Usuarios(props: IUsuarios) {
    const lstSelecionadosVinculados = useRef<Array<usuarioGrupo>>([]);
    const lstSelecionadosNaoVinculados = useRef<Array<usuarioGrupo>>([]);

    const {
        execute: ListarUsuariosPorGrupo,
        value: lstUsuarioPorGrupo,
        loading: lstUsuarioPorGrupoLoading,
    } = useAsyncEffect(
        () => ListarUsuariosPorGrupoController(props.idGrupo),
        [props.idGrupo]
    );

    const {
        execute: ListarUsuariosPorGrupoNaoVinculados,
        value: lstUsuariosPorGrupoNaoVinculados,
        loading: lstUsuariosPorGrupoNaoVinculadosLoading,
    } = useAsyncEffect(
        () => ListarUsuariosPorGrupoNaoVinculadosController(props.idGrupo),
        [props.idGrupo]
    );

    const {
        execute: VincularGruposUsuario,
        loading: VincularGruposUsuarioLoading,
    } = useAsyncCallback(VincularGruposUsuarioController);

    const {
        execute: DesVincularUsuariosGrupos,
        loading: DesVincularUsuariosGruposLoading,
    } = useAsyncCallback(DesVincularUsuarioGrupoController);

    function handleDesvincularUsuariosPorGrupo() {
        DesVincularUsuariosGrupos(
            props.idGrupo,
            lstSelecionadosNaoVinculados.current.map(
                (lst) => lst.ID_USUARIO ?? 0
            )
        ).then(() => {
            props.updateUsers(props.idGrupo);
            lstSelecionadosVinculados.current = [];
            lstSelecionadosNaoVinculados.current = [];
            ListarUsuariosPorGrupoNaoVinculados();
            ListarUsuariosPorGrupo();
        });
    }

    function handleVincularUsuariosPorGrupo() {
        VincularGruposUsuario(
            lstSelecionadosVinculados.current.map((lst) => ({
                ID_GRUPO: props.idGrupo,
                ID_USUARIO: lst.ID_USUARIO ?? 0,
            }))
        ).then(() => {
            props.updateUsers(props.idGrupo);
            lstSelecionadosVinculados.current = [];
            lstSelecionadosNaoVinculados.current = [];
            ListarUsuariosPorGrupoNaoVinculados();
            ListarUsuariosPorGrupo();
        });
    }

    return (
        <>
            <div className="Row2 flex-lg-row-fluid d-flex flex-column flex-lg-row mt-5">
                <div className="col-12 col-lg-6">
                    <UsuariosVinculadosPorGrupo
                        lstUsuarioPorGrupo={lstUsuarioPorGrupo}
                        lstUsuarioPorGrupoLoading={lstUsuarioPorGrupoLoading}
                        lstSelecionadosNaoVinculados={
                            lstSelecionadosNaoVinculados
                        }
                        VincularGruposUsuario={VincularGruposUsuario}
                        VincularGruposUsuarioLoading={
                            VincularGruposUsuarioLoading
                        }
                        idGrupo={props.idGrupo}
                        handleDesvincularUsuariosPorGrupo={
                            handleDesvincularUsuariosPorGrupo
                        }
                        DesVincularUsuariosGrupos={DesVincularUsuariosGrupos}
                        DesVincularUsuariosGruposLoading={
                            DesVincularUsuariosGruposLoading
                        }
                        lstUsuariosPorGrupoNaoVinculadosLoading={
                            lstUsuariosPorGrupoNaoVinculadosLoading
                        }
                        ListarUsuariosPorGrupo={ListarUsuariosPorGrupo}
                        ListarUsuariosPorGrupoNaoVinculados={
                            ListarUsuariosPorGrupoNaoVinculados
                        }
                        updateUsers={props.updateUsers}
                    />
                </div>
                <div className="col-12 col-lg-6">
                    <UsuariosDesvinculadosPorGrupo
                        lstUsuariosPorGrupoNaoVinculados={
                            lstUsuariosPorGrupoNaoVinculados
                        }
                        lstUsuariosPorGrupoNaoVinculadosLoading={
                            lstUsuariosPorGrupoNaoVinculadosLoading
                        }
                        VincularGruposUsuario={VincularGruposUsuario}
                        VincularGruposUsuarioLoading={
                            VincularGruposUsuarioLoading
                        }
                        idGrupo={props.idGrupo}
                        handleVincularUsuariosPorGrupo={
                            handleVincularUsuariosPorGrupo
                        }
                        lstUsuarioPorGrupoLoading={lstUsuarioPorGrupoLoading}
                        ListarUsuariosPorGrupo={ListarUsuariosPorGrupo}
                        ListarUsuariosPorGrupoNaoVinculados={
                            ListarUsuariosPorGrupoNaoVinculados
                        }
                        lstSelecionadosVinculados={lstSelecionadosVinculados}
                        updateUsers={props.updateUsers}
                    />
                </div>
            </div>
        </>
    );
}
